import { render, staticRenderFns } from "./MedicalRepRates.vue?vue&type=template&id=d4d16e90&scoped=true"
import script from "./MedicalRepRates.vue?vue&type=script&lang=js"
export * from "./MedicalRepRates.vue?vue&type=script&lang=js"
import style0 from "./MedicalRepRates.vue?vue&type=style&index=0&id=d4d16e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d16e90",
  null
  
)

export default component.exports